module.exports = __webpack_public_path__ + "static/home-video-poster-6c7a501cc8df5b9d9de92464963cba7e.webp";